import { render, staticRenderFns } from "./section-group.vue?vue&type=template&id=1084d97a&"
import script from "./section-group.vue?vue&type=script&lang=js&"
export * from "./section-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "section-group.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/business/select-member/section/section-group.vue
// module id = 201
// module chunks = 0